import { render, staticRenderFns } from "./BreadDataTableCell.vue?vue&type=template&id=1fe535e1&scoped=true&"
import script from "./BreadDataTableCell.vue?vue&type=script&lang=js&"
export * from "./BreadDataTableCell.vue?vue&type=script&lang=js&"
import style0 from "./BreadDataTableCell.vue?vue&type=style&index=0&id=1fe535e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe535e1",
  null
  
)

export default component.exports